// extracted by mini-css-extract-plugin
export default {"warning-text":"components-settings-recommendations-minimum-price-difference-module__warning-text"};